
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("gwd74"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("gwd74", function(module, exports) {

let $c069ce80812d64fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c069ce80812d64fe$var$load("5wVuh"),
    $c069ce80812d64fe$var$load("4NznW"),
    $c069ce80812d64fe$var$load("1F7LX"),
    $c069ce80812d64fe$var$load("byHKo"),
    $c069ce80812d64fe$var$load("2Sb1F"),
    $c069ce80812d64fe$var$load("10E5t"),
    $c069ce80812d64fe$var$load("gknbb"),
    $c069ce80812d64fe$var$load("6iz6l"),
    $c069ce80812d64fe$var$load("4SCW2"),
    $c069ce80812d64fe$var$load("36QeB"),
    $c069ce80812d64fe$var$load("9q75n"),
    $c069ce80812d64fe$var$load("iYHbd"),
    $c069ce80812d64fe$var$load("7aMek"),
    $c069ce80812d64fe$var$load("3q2Ng"),
    $c069ce80812d64fe$var$load("jRpDi"),
    $c069ce80812d64fe$var$load("3GuOt"),
    $c069ce80812d64fe$var$load("jbM5v"),
    $c069ce80812d64fe$var$load("dek7I"),
    $c069ce80812d64fe$var$load("dYtBN"),
    $c069ce80812d64fe$var$load("kNV5Y"),
    $c069ce80812d64fe$var$load("6SWFK"),
    $c069ce80812d64fe$var$load("9aQIt"),
    $c069ce80812d64fe$var$load("5zapo"),
    $c069ce80812d64fe$var$load("3MYQs"),
    $c069ce80812d64fe$var$load("XZauT"),
    $c069ce80812d64fe$var$load("4S1SF"),
    $c069ce80812d64fe$var$load("jiFtb"),
    $c069ce80812d64fe$var$load("lm9Lt"),
    $c069ce80812d64fe$var$load("9atVd"),
    $c069ce80812d64fe$var$load("9wPDc"),
    $c069ce80812d64fe$var$load("1MWOL"),
    $c069ce80812d64fe$var$load("6fQco"),
    $c069ce80812d64fe$var$load("aOY32"),
    $c069ce80812d64fe$var$load("7jSfd"),
    $c069ce80812d64fe$var$load("4HZlX"),
    $c069ce80812d64fe$var$load("kDqHr"),
    $c069ce80812d64fe$var$load("6wr18"),
    $c069ce80812d64fe$var$load("gT8XU"),
    $c069ce80812d64fe$var$load("8bhm4"),
    $c069ce80812d64fe$var$load("ffEVr"),
    $c069ce80812d64fe$var$load("7EorR"),
    $c069ce80812d64fe$var$load("8HygH"),
    $c069ce80812d64fe$var$load("G9L45"),
    $c069ce80812d64fe$var$load("kuFG2"),
    $c069ce80812d64fe$var$load("hhss7"),
    $c069ce80812d64fe$var$load("Wowvf"),
    $c069ce80812d64fe$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("2u4ha"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("2u4ha", function(module, exports) {

let $1cf1b3389b96ce66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1cf1b3389b96ce66$var$load("6wr18"),
    $1cf1b3389b96ce66$var$load("7aMek"),
    $1cf1b3389b96ce66$var$load("8bhm4"),
    $1cf1b3389b96ce66$var$load("ffEVr"),
    $1cf1b3389b96ce66$var$load("2tIxk"),
    $1cf1b3389b96ce66$var$load("dLq4a"),
    $1cf1b3389b96ce66$var$load("hhss7"),
    $1cf1b3389b96ce66$var$load("aQh37"),
    $1cf1b3389b96ce66$var$load("bJVDE"),
    $1cf1b3389b96ce66$var$load("8HygH"),
    $1cf1b3389b96ce66$var$load("G9L45"),
    $1cf1b3389b96ce66$var$load("kuFG2"),
    $1cf1b3389b96ce66$var$load("1F7LX"),
    $1cf1b3389b96ce66$var$load("10E5t"),
    $1cf1b3389b96ce66$var$load("h3ABO"),
    $1cf1b3389b96ce66$var$load("kC80R"),
    $1cf1b3389b96ce66$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("8M0PZ"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("8M0PZ", function(module, exports) {

let $01a5fdc0f9a09dfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01a5fdc0f9a09dfd$var$load("cnl5R"),
    $01a5fdc0f9a09dfd$var$load("2qnH2"),
    $01a5fdc0f9a09dfd$var$load("b9CA3"),
    $01a5fdc0f9a09dfd$var$load("2YffH"),
    $01a5fdc0f9a09dfd$var$load("lUDr0"),
    $01a5fdc0f9a09dfd$var$load("8dwgS"),
    $01a5fdc0f9a09dfd$var$load("9XOeB"),
    $01a5fdc0f9a09dfd$var$load("xu7ej"),
    $01a5fdc0f9a09dfd$var$load("iQ4FP"),
    $01a5fdc0f9a09dfd$var$load("71gca"),
    $01a5fdc0f9a09dfd$var$load("cp5Kz"),
    $01a5fdc0f9a09dfd$var$load("82Jpo"),
    $01a5fdc0f9a09dfd$var$load("bDpLy"),
    $01a5fdc0f9a09dfd$var$load("d2YjW"),
    $01a5fdc0f9a09dfd$var$load("im1VN"),
    $01a5fdc0f9a09dfd$var$load("eFu2n"),
    $01a5fdc0f9a09dfd$var$load("czOM6"),
    $01a5fdc0f9a09dfd$var$load("jWHz7"),
    $01a5fdc0f9a09dfd$var$load("7o9KM"),
    $01a5fdc0f9a09dfd$var$load("j8WjL"),
    $01a5fdc0f9a09dfd$var$load("f1rEg"),
    $01a5fdc0f9a09dfd$var$load("k7tiZ"),
    $01a5fdc0f9a09dfd$var$load("9anPW"),
    $01a5fdc0f9a09dfd$var$load("b2FtX"),
    $01a5fdc0f9a09dfd$var$load("gnDXu"),
    $01a5fdc0f9a09dfd$var$load("dl2qY"),
    $01a5fdc0f9a09dfd$var$load("kL5FA"),
    $01a5fdc0f9a09dfd$var$load("6iz6l"),
    $01a5fdc0f9a09dfd$var$load("4SCW2"),
    $01a5fdc0f9a09dfd$var$load("9q75n"),
    $01a5fdc0f9a09dfd$var$load("iYHbd"),
    $01a5fdc0f9a09dfd$var$load("3q2Ng"),
    $01a5fdc0f9a09dfd$var$load("jRpDi"),
    $01a5fdc0f9a09dfd$var$load("5wVuh"),
    $01a5fdc0f9a09dfd$var$load("4NznW"),
    $01a5fdc0f9a09dfd$var$load("41PFq"),
    $01a5fdc0f9a09dfd$var$load("jE9nA"),
    $01a5fdc0f9a09dfd$var$load("c0JsV"),
    $01a5fdc0f9a09dfd$var$load("h3ABO"),
    $01a5fdc0f9a09dfd$var$load("3b4Vy"),
    $01a5fdc0f9a09dfd$var$load("jyDas"),
    $01a5fdc0f9a09dfd$var$load("1oHTu"),
    $01a5fdc0f9a09dfd$var$load("juJ52"),
    $01a5fdc0f9a09dfd$var$load("8HygH"),
    $01a5fdc0f9a09dfd$var$load("G9L45"),
    $01a5fdc0f9a09dfd$var$load("6wr18"),
    $01a5fdc0f9a09dfd$var$load("jvHRs"),
    $01a5fdc0f9a09dfd$var$load("9XYQ9"),
    $01a5fdc0f9a09dfd$var$load("Wowvf"),
    $01a5fdc0f9a09dfd$var$load("2tIxk"),
    $01a5fdc0f9a09dfd$var$load("dLq4a"),
    $01a5fdc0f9a09dfd$var$load("ffEVr"),
    $01a5fdc0f9a09dfd$var$load("hhss7"),
    $01a5fdc0f9a09dfd$var$load("aQh37"),
    $01a5fdc0f9a09dfd$var$load("bJVDE"),
    $01a5fdc0f9a09dfd$var$load("1F7LX"),
    $01a5fdc0f9a09dfd$var$load("10E5t"),
    $01a5fdc0f9a09dfd$var$load("jnVKv"),
    $01a5fdc0f9a09dfd$var$load("7EorR"),
    $01a5fdc0f9a09dfd$var$load("bgHzk"),
    $01a5fdc0f9a09dfd$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.73b61021.js.map
